import EdgeStyleContainer from "../../Componant/Buttons/EdgeStyle";

const EdgeStyle = () => {
  return (
    <div className="page-body">
      <EdgeStyleContainer />
    </div>
  );
};

export default EdgeStyle;
